import { nanoid } from 'nanoid';

import { SET_ALERT, REMOVE_ALERT } from './types';

export const setAlert =
  (msg, alertType, type = 'general', timeout = 5000) =>
  (dispatch) => {
    const id = nanoid(15);
    dispatch({
      type: SET_ALERT,
      payload: { msg, alertType, id, type },
    });

    setTimeout(() => dispatch({ type: REMOVE_ALERT, payload: id }), timeout);
  };
